import React, { useContext, useEffect, useState } from 'react';
import './filters.scss';
import PropTypes from 'prop-types';
import { getUniquePeriodNames, getUniqueYears } from '../declarePeriodUtil';
import MultiSelectSearchDropdown from '../../../../Components/MultiFilterSearch/multiFilterSearch';
import { DECLARE_PERFORMANCE_PERIOD } from '../../../../Constants/strings';
import AddIcon from '@mui/icons-material/Add';
import ButtonComponent from '../../../../Components/Button/button';
import { AuthContext } from '../../../../Contexts/AuthContext';
import AddEditPerformanceCycleForm from '../../AddPerformanceCycle/addPerformanceCycle';
import { MODULE_NAMES } from '../../../../Constants/modules';

const Filter = ({ filterData, selectedYear, setSelectedYear, selectedPerformanceType, setSelectedPerformanceType,
  updatePerformanceCycleList}) => {
  const [yearList, setYearList] = useState([]);
  const [periodList, setPeriodList] = useState([]);
  const { userProfile } = useContext(AuthContext);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const permission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.MASTER_PERFORMANCE_PERIOD] || []
    : [];

  const hasAccess = (action) => {
    return permission.includes(action);
  };

  useEffect(() => {
    getUniqueYears(filterData)
      .then(setYearList);

    getUniquePeriodNames(filterData)
      .then(setPeriodList);
  }, [filterData]);

  const handleYearFilter = (event) => {
    setSelectedYear(event.target.value);
  };

  const handlePerformanceTypeFilter = (event) => {
    setSelectedPerformanceType(event.target.value);
  };

  return (
    <div className="filters-and-add-button-layout">
      <div className="filter-container">
        <div className='filter-year-container'>
          <MultiSelectSearchDropdown
            dropdownCss="filter-year"
            options={yearList}
            value={selectedYear}
            onChange={handleYearFilter}
            placeholder={DECLARE_PERFORMANCE_PERIOD.FILTERS.YEAR}
            autoFocus={true}
            size="small"
            id="year-filter"
            SearchPlaceHolder={DECLARE_PERFORMANCE_PERIOD.FILTERS.YEAR}
            showFilterIcon={false}
            disabled={yearList.length === 0}
          />
        </div>

        <div className='filter-performance-type-container'>
          <MultiSelectSearchDropdown
            dropdownCss="filter-performance-type"
            options={periodList}
            value={selectedPerformanceType}
            onChange={handlePerformanceTypeFilter}
            placeholder={DECLARE_PERFORMANCE_PERIOD.FILTERS.PERFORMANCE_TYPE}
            autoFocus={true}
            size="small"
            id="performance-type-filter"
            SearchPlaceHolder={DECLARE_PERFORMANCE_PERIOD.FILTERS.PERFORMANCE_TYPE}
            showFilterIcon={false}
            disabled={periodList.length === 0}
          />
        </div>
      </div>

      <div className="add-button-container">
        <ButtonComponent
          disabled={!hasAccess('create')} // Disable add button based on permission
          label={DECLARE_PERFORMANCE_PERIOD.ADD_BUTTON_TEXT}
          variant="contained"
          onClick={() => {
            setAddModalOpen(true);
          }}
          startIcon={<AddIcon />}
          btnCss={
            !hasAccess('create')
              ? 'add-period-btn-disabled'
              : 'add-period-btn'
          }
        ></ButtonComponent>
      </div>
      <AddEditPerformanceCycleForm
        modalOpen={addModalOpen}
        handleClose={() => {
          setAddModalOpen(false);
        }}
        lastUpdatedBy={userProfile?.user_name}
        updatePerformanceCycleList={updatePerformanceCycleList}
        isEdit={false}
      />
    </div>
  );
};

Filter.propTypes = {
  filterData: PropTypes.array.isRequired,
  selectedYear: PropTypes.array.isRequired,
  setSelectedYear: PropTypes.func.isRequired,
  selectedPerformanceType: PropTypes.array.isRequired,
  setSelectedPerformanceType: PropTypes.func.isRequired,
  updatePerformanceCycleList: PropTypes.func.isRequired,
};

export default Filter;
